// @ actions
const signaturePatternActions = require('actions/signaturePattern');
const hireCardImageSelectorActions = require('actions/hireCardImageSelector');
const hireCardNameSelectorActions = require('actions/hireCardNameSelector');
const hireContactDataActions = require('actions/hireContactData');
const hireCreditLimitActions = require('actions/hireCreditLimit');
const hireInformationActions = require('actions/hireInformation');
const hirePaymentMethodActions = require('actions/hirePaymentMethod');
const hireCardCreditINE = require('actions/commons/hireCardCreditINE');
const { updateConsents } = require('actions/gdprConsents');
const { setShippingAddress, resetShippingAddress } = require('actions/shippingAddress');
const { resetPreContractualInfo } = require('actions/preContractualInfo');
const { setTermsAndCondsInfo } = require('actions/termsAndCondsInfo');
const { setTermsAndCondsInfoRevolving } = require('actions/cardRevolvingDocuments');

// @ utilities
const { APIPost } = require('utilities/APIRequestHelper');
const PersonalDataHelper = require('utilities/personalDataHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const { getCCOfficeChannel, isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const {
  getCardStandard,
  getCreditCardHiringStatus,
  getShippingAddressDetails,
} = require('utilities/hireCardsHelper');
const { get } = require('lodash');

// @ constants
const actionTypes = require('constants/actionTypes');
const {
  API_CHANNEL,
  CREDIT_CARD_SUBTYPE_PREMIUM,
  CREDIT_CARD_TYPE_PACK,
  THIRD_STEP,
  CREDIT_CARD_SUBTYPE_VISA,
  CREDIT_CARD_TYPE_VISA
} = require('constants/index');
const { formatText } = require('core/i18n').i18n;

const { NEW_SHIPPING_ADDRESS } = require('constants/shippingAddress');
const { PREMIUM_PACK_PRODUCT_ALIAS } = require('constants/hiringProductInformation');
const { CREDIT_CARD_REVOLVING_PROCESS, MESSAGE_HIRE_24H, NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES } = require('constants/flagBasedFeatures');
function resetWizard() {
  return {
    type: actionTypes.HIRE_CARD_PREMIUM_PACK_RESET,
  };
}

function onHandleChangeCheckBoxCC() {
  return {
    type: actionTypes.HIRE_CARD_PREMIUM_PACK_SET_AGREEMENT_CHECKBOX_CC
  };
}

const reset = () => dispatch => {
  dispatch(hireCardImageSelectorActions.reset());
  dispatch(hireCardNameSelectorActions.reset());
  dispatch(hireContactDataActions.reset());
  dispatch(hireCreditLimitActions.reset());
  dispatch(hireInformationActions.reset());
  dispatch(hirePaymentMethodActions.reset());
  dispatch(resetShippingAddress());
  dispatch(resetWizard());
  dispatch(resetPreContractualInfo());
};

function setAccount(accountId) {
  return {
    type: actionTypes.HIRE_CARD_PREMIUM_PACK_SET_ACCOUNT,
    payload: {
      accountId,
    },
  };
}

const setAgreementCheckbox = (evt, stepToUpdate = undefined) => {
  const { checked } = evt.target;
  return {
    type: actionTypes.HIRE_CARD_PREMIUM_PACK_SET_AGREEMENT_CHECKBOX,
    payload: {
      checked,
      stepToUpdate,
    },
  };
};

function setVisibleStep(step) {
  return {
    type: actionTypes.HIRE_CARD_PREMIUM_PACK_SET_VISIBLE_STEP,
    payload: {
      step,
    },
  };
}

const setAllAccountsToInactive = () => ({
  type: actionTypes.HIRE_CARD_PREMIUM_PACK_SET_ALL_ACCOUNTS_TO_INACTIVE,
});

function validateAccount() {
  return {
    type: actionTypes.HIRE_CARD_PREMIUM_PACK_VALIDATE_ACCOUNT,
  };
}

function processEmailSuccess() {
  return {
    type: actionTypes.HIRE_CARD_PREMIUM_PACK_PROCCESS_EMAIL_SUCCESS,
  };
}
function processEmailError() {
  return {
    type: actionTypes.HIRE_CARD_PREMIUM_PACK_PROCCESS_EMAIL_ERROR,
  };
}

function validateLoading(loadingFlag) {
  return {
    type: actionTypes.HIRE_CARD_LOADING,
    payload: {
      loadingFlag,
    },
  };
}

function validate(step, externalComponentsAreValid, isRevolving = false) {
  return {
    type: actionTypes.HIRE_CARD_PREMIUM_PACK_VALIDATE_STEP,
    payload: {
      step,
      valid: externalComponentsAreValid,
      isRevolving,
    },
  };
}


function newValidate(step, externalComponentsAreValid, isRevolving = false) {
  return {
    type: actionTypes.HIRE_CARD_PREMIUM_PACK_NEW_VALIDATE_STEP,
    payload: {
      step,
      valid: externalComponentsAreValid,
      isRevolving,
    },
  };
}

function hireCardPremiumPackPrintDocument() {
  return {
    type: actionTypes.HIRE_CARD_PREMIUM_PACK_PRINT_DOCUMENT,

  };
}
function hireCardPremiumPackprintDocumentPolicy() {
  return {
    type: actionTypes.HIRE_CARD_PREMIUM_PACK_PRINT_DOCUMENT_POLICY,
  };
}

function hireCardPremiumPackCheckedRadioButton(check) {
  return {
    type: actionTypes.HIRE_CARD_PREMIUM_PACK_CHECK_RADIO_BUTTON,
    payload: {
      check,
    },
  };
}

function hireCardPremiumPackCheckedRadioButtonPolicy(check) {
  return {
    type: actionTypes.HIRE_CARD_PREMIUM_PACK_CHECK_RADIO_BUTTON_POLICY,
    payload: {
      check,
    },
  };
}

function agreeIneCheckbox() {
  return {
    type: actionTypes.HIRE_CARD_PREMIUM_PACK_AGREEINECHECKBOX,

  };
}
const validateFirstAndFifthStep = step => (dispatch, getState) => {
  const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
  dispatch(validate(step, true, showIneAndRevolving));
};

const validateSecondStep = step => (dispatch, getState) => {
  const immHireCardImageSelector = getState().hireCardImageSelector;
  const externalComponentsAreValid = immHireCardImageSelector.get('valid');
  dispatch(validate(step, externalComponentsAreValid));
};

const validateThirdStep = step => (dispatch, getState) => {
  const immHirePaymentMethod = getState().hirePaymentMethod;
  const immHireCreditLimit = getState().hireCreditLimit;
  const accountIsValid = getState().hireCardPremiumPack.getIn([
    'steps',
    step - 1,
    'accountIsValid',
  ]);

  let allComponentsAreValid =
    immHirePaymentMethod.get('valid') && immHireCreditLimit.get('valid') && accountIsValid;

  if (
    allComponentsAreValid &&
    immHireCreditLimit.get('maxValueToAuthorize') > 0 &&
    immHireCreditLimit.get('creditLimit') > immHireCreditLimit.get('maxValueToAuthorize') &&
    immHireCreditLimit.get('minValue') <= immHireCreditLimit.get('maxValueToAuthorize')
  ) {
    dispatch(hireCreditLimitActions.toggleModal(true));
  } else {
    dispatch(validate(step, allComponentsAreValid));
  }
};

const validateFourthStep = step => (dispatch, getState) => {
  const immShippingAddress = getState().shippingAddress;
  const shippingAddressType = immShippingAddress.get('shippingAddressType');
  let allComponentsAreValid = true;

  if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
    //Send param false in validateStep to show absence of mobile field
    dispatch(hireContactDataActions.validateStep(false));
    const immHireContactData = getState().hireContactData;
    allComponentsAreValid = immHireContactData.get('isValid');

    dispatch(validate(step, allComponentsAreValid));

    if (step == 4) {
      dispatch(validate(step, allComponentsAreValid));
    } else {
      __CONTACT_CENTER__ && !isPrintOfficeMode() ? dispatch(validate(step, allComponentsAreValid)) : dispatch(newValidate(step, allComponentsAreValid));
    }
    //Set shipping address as new correspondance address
    allComponentsAreValid && dispatch(setShippingAddress(NEW_SHIPPING_ADDRESS, immHireContactData));
  } else {
    if (step == 4) {
      dispatch(validate(step, allComponentsAreValid));
    } else {

      __CONTACT_CENTER__ && !isPrintOfficeMode() ? dispatch(validate(step, allComponentsAreValid)) : dispatch(newValidate(step, allComponentsAreValid));
    }
  }
};

const validateINEStep = step => (dispatch, getState) => {
  const immShippingAddress = getState().shippingAddress;
  const shippingAddressType = immShippingAddress.get('shippingAddressType');
  let allComponentsAreValid = true;
  const immHireCardPremiumPack = getState().hireCardPremiumPack;
  const documentINE = immHireCardPremiumPack.get('documentINE')
  if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
    dispatch(hireContactDataActions.validateStep(false));
    const immHireContactData = getState().hireContactData;
    allComponentsAreValid = immHireContactData.get('isValid');
    dispatch(validate(step, allComponentsAreValid))
    return dispatch(hireCardCreditINE.getInitINEstep(immHireCardPremiumPack));
  } else {
    dispatch(validate(step, allComponentsAreValid))
    return dispatch(hireCardCreditINE.getInitINEstep(immHireCardPremiumPack));

  }
};
const validatePolicyStep = () => (dispatch, getState) => {
  const immHireCardPremiumPack = getState().hireCardPremiumPack;
  const documentPolicy = immHireCardPremiumPack.get('documentPolicy')
  !documentPolicy && dispatch(hireCardCreditINE.getInitPolicystep(immHireCardPremiumPack));;
};

const getStep = step => (dispatch, getState) => {
  const valid = getState().hireCardPremiumPack.getIn(['steps', step - 1, 'valid']);
  if (!valid) {
    scrollToTop();
  }
  return valid;
};

const processEmail = () => (dispatch, getState) => {
  const productType = getState().hireCreditLimit.get('productType');
  const productSubType = getState().hireCreditLimit.get('productSubType');
  const standard = getState().hireCreditLimit.get('referenceStandard');
  const immHireCardPremiumPack = getState().hireCardPremiumPack;
  const documentId = immHireCardPremiumPack.get('documentId')
  const operationProcessIdInit = immHireCardPremiumPack.get('operationProcessIdInit')
  const scrollDown = immHireCardPremiumPack.get('scrollDown')
  const acceptanceText = isPrintOfficeMode() ? formatText('hireCardOpenCreditStepINE-acceptanceTextOffice') :
    !__CONTACT_CENTER__ && !isPrintOfficeMode ? formatText('hireCardOpenCreditStepINE-labelCheckbox') : formatText('hireCardOpenCredit-step4NewCheckboxText')
  const params = {
    query: {

      product: {
        type: productType,
        subtype: productSubType,
        standard: standard
      },
      contactCenter: false,
      sendInsuranceDocument: true,
      sendRelevantRevolvingDocument: false,
      documentId,
      contractNumber: 0,
      mailType: "precontractual",
      operationProcessId: operationProcessIdInit,
      acceptanceText,
      scrollDown,
    }
  };

  APIPost({
    dispatch,
    endpoint: 'hiringCardsSimple',
    params
  })
    .then(() => {
      dispatch(processEmailSuccess());
    })
    .catch(response => {
      if (!!response.error) {
        dispatch(processEmailError());
 
      }
    });
};

const validateStep = step => (dispatch, getState) => {
  const cardsFeatureFlag = getState().flagBasedFeatures
  const newCardsFF = cardsFeatureFlag.get(NOT_ALLOWED_NEW_CREDIT_CARDS_FLOW_COUNTRIES)
  if (newCardsFF) {
    if (__CONTACT_CENTER__ && !isPrintOfficeMode()) {
      if (step === 1 && cardsFeatureFlag.get(MESSAGE_HIRE_24H)) {
        const immCards = getState().cards;
        const immCardById = immCards && immCards.get('byId');
        const immCardByOrder = immCards && immCards.get('byOrder');

        const cardObj =
          immCardByOrder &&
          immCardByOrder.map(cardId => {
            const immCard = immCardById && immCardById.get(cardId);
            return {
              contractNumber: immCard.getIn(['contract', 'number']),
              pan: immCard.get('number'),
              product: immCard.get('newProduct'),
              subType: immCard.get('productSubType'),
              standard: immCard.getIn(['product', 'standard']),
            };
          });
        dispatch(validateLoading(true));
        return APIPost({
          dispatch,
          endpoint: 'validateCardHire',
          params: {
            query: { cards: cardObj },
          },
        })
          .then(() => {
            dispatch(validateLoading(false));
            dispatch(validate(step, false));
          })
          .catch(error => {
            if (error) {
              if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
                dispatch(validate(step, true));
                dispatch(validateLoading(false));
              } else {
                dispatch(hireCardPremiumPackFailure());
                dispatch(validateLoading(false));
              }
            }
          });
      } else if (step === 2) {
        //SECOND_STEP
        dispatch(hireCardImageSelectorActions.validateStep());
        dispatch(validateSecondStep(step));
      } else if (step === 3) {
        //THIRD_STEP
        dispatch(validateAccount());
        dispatch(hireCreditLimitActions.validateStep());
        dispatch(hirePaymentMethodActions.validateStep());
        dispatch(validateThirdStep(step));
      } else if (step === 4) {
        //FOURTH_STEP
        dispatch(validateINEStep(step))
          .then(() => {
            dispatch(validatePolicyStep());
          })
      } else if (step === 1 || step === 5) {
        //FIRST_STEP AND FIFTH_STEP
        dispatch(validateFirstAndFifthStep(step));
      } else {
        dispatch(validateLoading(false));
        dispatch(validate(step, false));
      }
      return dispatch(getStep(step));

    } else {

      if (step === 1 && cardsFeatureFlag.get(MESSAGE_HIRE_24H)) {
        const immCards = getState().cards;
        const immCardById = immCards && immCards.get('byId');
        const immCardByOrder = immCards && immCards.get('byOrder');

        const cardObj =
          immCardByOrder &&
          immCardByOrder.map(cardId => {
            const immCard = immCardById && immCardById.get(cardId);
            return {
              contractNumber: immCard.getIn(['contract', 'number']),
              pan: immCard.get('number'),
              product: immCard.get('newProduct'),
              subType: immCard.get('productSubType'),
              standard: immCard.getIn(['product', 'standard']),
            };
          });
        dispatch(validateLoading(true));
        return APIPost({
          dispatch,
          endpoint: 'validateCardHire',
          params: {
            query: { cards: cardObj },
          },
        })
          .then(() => {
            dispatch(validateLoading(false));
            dispatch(validate(step, false));
          })
          .catch(error => {
            if (error) {
              if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
                dispatch(validate(step, true));
                dispatch(validateLoading(false));
              } else {
                dispatch(hireCardPremiumPackFailure());
                dispatch(validateLoading(false));
              }
            }
          });
      } else if (step === 2) {
        dispatch(hireCardImageSelectorActions.validateStep());
        dispatch(validateSecondStep(step));
      } else if (step === 3) {
        dispatch(validateAccount());
        dispatch(hireCreditLimitActions.validateStep());
        dispatch(hirePaymentMethodActions.validateStep());
        dispatch(validateThirdStep(step));
      } else if (step === 4) {
        dispatch(validateINEStep(step));
      } else if (step === 5) {
        dispatch(validatePolicyStep());
        dispatch(processEmail());
        dispatch(validateFourthStep(step));
        !isPrintOfficeMode() && dispatch(agreeIneCheckbox())
      } else if (step === 1 || step === 6) {
        dispatch(validateFirstAndFifthStep(step));
      } else {
        dispatch(validateLoading(false));
        dispatch(validate(step, false));
      }
      return dispatch(getStep(step));
    }
  } else {
    if (step === 1 && cardsFeatureFlag.get(MESSAGE_HIRE_24H)) {
      const immCards = getState().cards;
      const immCardById = immCards && immCards.get('byId');
      const immCardByOrder = immCards && immCards.get('byOrder');

      const cardObj =
        immCardByOrder &&
        immCardByOrder.map(cardId => {
          const immCard = immCardById && immCardById.get(cardId);
          return {
            contractNumber: immCard.getIn(['contract', 'number']),
            pan: immCard.get('number'),
            product: immCard.get('newProduct'),
            subType: immCard.get('productSubType'),
            standard: immCard.getIn(['product', 'standard']),
          };
        });
      dispatch(validateLoading(true));
      return APIPost({
        dispatch,
        endpoint: 'validateCardHire',
        params: {
          query: { cards: cardObj },
        },
      })
        .then(() => {
          dispatch(validateLoading(false));
          dispatch(validate(step, false));
        })
        .catch(error => {
          if (error) {
            if (error.error.status === 412 && error.body.error === 'HIRE_BLOCKED') {
              dispatch(validate(step, true));
              dispatch(validateLoading(false));
            } else {
              dispatch(hireCardPremiumPackFailure());
              dispatch(validateLoading(false));
            }
          }
        });
    } else if (step === 2) {
      //SECOND_STEP
      dispatch(hireCardImageSelectorActions.validateStep());
      dispatch(validateSecondStep(step));
    } else if (step === 3) {
      //THIRD_STEP
      dispatch(validateAccount());
      dispatch(hireCreditLimitActions.validateStep());
      dispatch(hirePaymentMethodActions.validateStep());
      dispatch(validateThirdStep(step));
    } else if (step === 4) {
      //FOURTH STEP
      dispatch(validateFourthStep(step));
    } else if (step === 1 || step === 5) {
      //FIRST_STEP AND FIFTH_STEP
      dispatch(validateFirstAndFifthStep(step));
    } else {
      dispatch(validateLoading(false));
      dispatch(validate(step, false));
    }
    return dispatch(getStep(step));
  }
};

function setWillCancel(willCancel) {
  return {
    type: actionTypes.HIRE_CARD_PREMIUM_PACK_WILL_CANCEL,
    payload: {
      willCancel,
    },
  };
}

const setCardHire = (dispatch, data, termsAndsCondsHiringData, showIneAndRevolving) => {
  const requestData = {
    query: data,
  };

  dispatch(hireCardPremiumPackRequest());
  return APIPost({
    dispatch,
    endpoint: 'myCardsTarjetasHire',
    params: requestData,
  })
    .then(response => {
      const status = getCreditCardHiringStatus(response);

      if (status.error) {
        dispatch(hireCardPremiumPackFailure(status.hiringStatus, status.errorMsg));
      } else {
        dispatch(hireCardPremiumPackSuccess(status.hiringStatus));
        const contractNumber = get(response, ['contratoTarjetaAltOnline', 'numeroContrato'], null);
        if (showIneAndRevolving && contractNumber) {
          dispatch(
            setTermsAndCondsInfoRevolving(
              PREMIUM_PACK_PRODUCT_ALIAS,
              termsAndsCondsHiringData,
              contractNumber
            )
          );
        } else {
          dispatch(setTermsAndCondsInfo(PREMIUM_PACK_PRODUCT_ALIAS, termsAndsCondsHiringData));
        }
      }
    })
    .catch(response => {
      const status = getCreditCardHiringStatus(response);
      if (status.error) {
        dispatch(hireCardPremiumPackFailure(status.hiringStatus, status.errorMsg));
      } else if (!!response.error) {
        dispatch(hireCardPremiumPackFailure());
      } else {
        throw response;
      }
    });
};

const myCardsTarjetasHire = () => (dispatch, getState) => {
  const immHireCardPremiumPack = getState().hireCardPremiumPack;
  const callback = (dispatch, getState, dataToken) => {
    const contractNumberAccount = immHireCardPremiumPack.get('contractNumberAccount')
    const immCreditLimit = getState().hireCreditLimit;
    const immPaymentMethod = getState().hirePaymentMethod;
    const cardDesignKey = getCardStandard(getState().hireCardImageSelector.get('selectedImageId'));
    const email = PersonalDataHelper.getEmail(getState().profile);
    const immShippingAddress = getState().shippingAddress;
    const shippingAddressType = immShippingAddress.get('shippingAddressType');
    const immHireCardNameSelector = getState().hireCardNameSelector;
    const selectedName = immHireCardNameSelector.getIn([
      'names',
      immHireCardNameSelector.get('selectedIndex'),
    ]);
    const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
    let addressDetails,
      numDomicilio = null;

    if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
      const immContactData = getState().hireContactData;
      addressDetails = getShippingAddressDetails(immContactData);
    } else {
      numDomicilio = immShippingAddress.getIn(['shippingAddress', 'numDomicilio']);
    }
    const acceptanceText = __CONTACT_CENTER__ && !isPrintOfficeMode() ? 'NA' : __CONTACT_CENTER__ && isPrintOfficeMode()? formatText('hireCardOpenCreditStepINE-acceptanceTextOffice'): formatText('hireCardOpenCreditHeaderPolicy-header')

    const data = {
      processType: 'contract',
      documentId: immHireCardPremiumPack.get('documentIdPolicy'),
      operationProcessId: immHireCardPremiumPack.get('operationProcessIdInitPolicy'),
      addressDetails: addressDetails,
      cardDetails: {
        cuentaCargo: contractNumberAccount,
        email,
        importeCuotaFormaPago: immPaymentMethod.get('value'),
        limiteSolicitado: immCreditLimit.get('creditLimit'),
        // todo nombreAdicional value
        nombreAdicional: '',
        nombreBeneficiario: selectedName,
        tarjetaRef: {
          canal: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
          standard: cardDesignKey,
          subTipo: CREDIT_CARD_SUBTYPE_PREMIUM,
          tipo: CREDIT_CARD_TYPE_PACK,
        },
        tipoFormaPago: immPaymentMethod.get('type'),
      },
      deliverToProvidedDetails: true,
      numDomicilio,
      dataToken,
      acceptanceText,
      scrollDown: immHireCardPremiumPack.get('scrollDownPolicy'),
    };

    const termsAndsCondsHiringData = [
      {
        standard: cardDesignKey,
        subType: CREDIT_CARD_SUBTYPE_PREMIUM,
        type: CREDIT_CARD_TYPE_PACK,
      },
    ];
    dispatch(updateConsents(dataToken))
      .then(() => {
        setCardHire(dispatch, data, termsAndsCondsHiringData, showIneAndRevolving)
      }
      )
      .catch(response => {
        if (!!response.error) {
          setCardOpenCredit(dispatch, data, termsAndsCondsHiringData, showIneAndRevolving);
        } else {
          throw response;
        }
      });
  };

  new Promise(() => {
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
  });
}

const checkRadioButton = (check) => (dispatch, getState) => {
  dispatch(hireCardPremiumPackCheckedRadioButton(check));
}
const checkRadioButtonPolicy = (check) => (dispatch, getState) => {
  dispatch(hireCardPremiumPackCheckedRadioButtonPolicy(check));
}
const printDocument = () => (dispatch, getState) => {
  dispatch(hireCardPremiumPackPrintDocument());
}
const printDocumentPolicy = () => (dispatch, getState) => {
  dispatch(hireCardPremiumPackprintDocumentPolicy());
}

const hireCardPremiumPackRequest = () => ({
  type: actionTypes.HIRE_CARD_PREMIUM_PACK_REQUEST,
});

const hireCardPremiumPackSuccess = hiringStatus => ({
  type: actionTypes.HIRE_CARD_PREMIUM_PACK_SUCCESS,
  payload: {
    hiringStatus,
  },
});

const hireCardPremiumPackFailure = (hiringStatus = '', errorMsg = '') => ({
  type: actionTypes.HIRE_CARD_PREMIUM_PACK_FAILURE,
  payload: {
    errorMsg,
    hiringStatus,
  },
});

const setCardPremiumPack = (dispatch, data, termsAndsCondsHiringData, showIneAndRevolving) => {
  const requestData = {
    header: {
      version: 2,
    },
    query: data,
  };

  dispatch(hireCardPremiumPackRequest());
  return APIPost({
    dispatch,
    endpoint: 'hireCreditCard',
    params: requestData,
  })
    .then(response => {
      const status = getCreditCardHiringStatus(response);

      if (status.error) {
        dispatch(hireCardPremiumPackFailure(status.hiringStatus, status.errorMsg));
      } else {
        dispatch(hireCardPremiumPackSuccess(status.hiringStatus));
        const contractNumber = get(response, ['contratoTarjetaAltOnline', 'numeroContrato'], null);
        if (showIneAndRevolving && contractNumber) {
          dispatch(
            setTermsAndCondsInfoRevolving(
              PREMIUM_PACK_PRODUCT_ALIAS,
              termsAndsCondsHiringData,
              contractNumber
            )
          );
        } else {
          dispatch(setTermsAndCondsInfo(PREMIUM_PACK_PRODUCT_ALIAS, termsAndsCondsHiringData));
        }
      }
    })
    .catch(response => {
      const status = getCreditCardHiringStatus(response);
      if (status.error) {
        dispatch(hireCardPremiumPackFailure(status.hiringStatus, status.errorMsg));
      } else if (!!response.error) {
        dispatch(hireCardPremiumPackFailure());
      } else {
        throw response;
      }
    });
};

const hireCardPremiumPack = () => (dispatch, getState) => {
  const callback = (dispatch, getState, dataToken) => {
    const accountId = getState().hireCardPremiumPack.getIn(['steps', THIRD_STEP, 'accountId']);
    const accountInfo = getState().accounts.getIn(['byId', accountId, 'ibanComplex', 'codbban']);
    const immCreditLimit = getState().hireCreditLimit;
    const immPaymentMethod = getState().hirePaymentMethod;
    const cardDesignKey = getCardStandard(getState().hireCardImageSelector.get('selectedImageId'));
    const email = PersonalDataHelper.getEmail(getState().profile);
    const immShippingAddress = getState().shippingAddress;
    const shippingAddressType = immShippingAddress.get('shippingAddressType');
    const immHireCardNameSelector = getState().hireCardNameSelector;
    const selectedName = immHireCardNameSelector.getIn([
      'names',
      immHireCardNameSelector.get('selectedIndex'),
    ]);
    const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
    let addressDetails,
      numDomicilio = null;

    if (shippingAddressType === NEW_SHIPPING_ADDRESS) {
      const immContactData = getState().hireContactData;
      addressDetails = getShippingAddressDetails(immContactData);
    } else {
      numDomicilio = immShippingAddress.getIn(['shippingAddress', 'numDomicilio']);
    }

    const data = {
      addressDetails,
      cardDetails: {
        cuentaCargo: accountInfo,
        email,
        importeCuotaFormaPago: immPaymentMethod.get('value'),
        limiteSolicitado: immCreditLimit.get('creditLimit'),
        //TODO: To be replace with actual data once get approved
        nombreAdicional: '',
        nombreBeneficiario: selectedName,
        tarjetaRef: {
          canal: __CONTACT_CENTER__ ? getCCOfficeChannel() : API_CHANNEL,
          standard: cardDesignKey,
          subTipo: CREDIT_CARD_SUBTYPE_PREMIUM,
          tipo: CREDIT_CARD_TYPE_PACK,
        },
        tipoFormaPago: immPaymentMethod.get('type'),
      },
      numDomicilio,
      deliverToProvidedDetails: true,
      dataToken,
    };

    const termsAndsCondsHiringData = [
      {
        standard: cardDesignKey,
        subType: CREDIT_CARD_SUBTYPE_PREMIUM,
        type: CREDIT_CARD_TYPE_PACK,
      },
    ];

    dispatch(updateConsents(dataToken))
      .then(() => setCardPremiumPack(dispatch, data, termsAndsCondsHiringData, showIneAndRevolving))
      .catch(response => {
        if (!!response.error) {
          setCardPremiumPack(dispatch, data, termsAndsCondsHiringData, showIneAndRevolving);
        } else {
          throw response;
        }
      });
  };

  new Promise(() => {
    signaturePatternActions.validateAndExecute(dispatch, getState, callback);
  });
};

module.exports = {
  hireCardPremiumPack,
  reset,
  setAccount,
  setAgreementCheckbox,
  setAllAccountsToInactive,
  setVisibleStep,
  setWillCancel,
  validate,
  validateStep,
  checkRadioButton,
  printDocument,
  processEmail,
  onHandleChangeCheckBoxCC,
  myCardsTarjetasHire,
  printDocumentPolicy,
  checkRadioButtonPolicy
};
